module.exports = __webpack_public_path__ + "static/img/homebar.f80618b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/homebar.jpg
// module id = hBGq
// module chunks = 1